import { FC, ReactNode } from 'react'
import { TimeAdjuster } from './components/TimeAdjuster'
import { DateTime } from 'luxon'

export type TimeWidgetProps = {
  autoFocusedAdjuster: 'start' | 'end'
  dateEditing: DateTime
  displayMode?: '12' | '24'
  endAtSecondsSinceMidnight: number | null
  fieldPrefix?: string
  onSubmit: (
    startAtSecondsSinceMidnight: number | null,
    endAtSecondsSinceMidnight: number | null,
    timeZone: string,
  ) => void
  renderTopRight?: () => ReactNode
  startAtSecondsSinceMidnight: number | null
  timeZone: string
  title: string
  variant?: 'time' | 'time-and-duration'
  minTime: DateTime
  maxTime: DateTime
}

/**
 * TODO - time widget tasks
 * - handle "short" input (e.g. 9h, 8 - as in 8:00 am)
 * - clean up error messaging/logic/display
 * - introduce tests to ensure edge cases are taken care of
 */
export const TimeWidget: FC<TimeWidgetProps> = ({
  autoFocusedAdjuster,
  dateEditing,
  displayMode = '12',
  endAtSecondsSinceMidnight,
  fieldPrefix,
  onSubmit: submit,
  renderTopRight = () => null,
  startAtSecondsSinceMidnight,
  timeZone,
  title,
  variant = 'time-and-duration',
  minTime,
  maxTime,
}) => {
  return (
    <div className="flex flex-col pt-3 pb-2 bg-white rounded cursor-default">
      <TimeAdjuster
        autoFocusedAdjuster={autoFocusedAdjuster}
        dateEditing={dateEditing}
        displayMode={displayMode}
        endTimeSinceMidnight={endAtSecondsSinceMidnight}
        fieldPrefix={fieldPrefix}
        onSubmit={submit}
        renderTopRight={renderTopRight}
        startTimeSinceMidnight={startAtSecondsSinceMidnight}
        timeZone={timeZone}
        title={title}
        variant={variant}
        minTime={minTime}
        maxTime={maxTime}
      />
    </div>
  )
}
